import store from '../store'

export default {
  computed: {
    jticketUrl: function(){ return (url, isLogin = false) => {
      let match = url.match(/(^.*?)(#.*$)/)
      return `${process.env.VUE_APP_JLEAGUE_TICKET}${match? match[1]: url}`
      + `${store.state.Auth.user || isLogin ? `${url.match(/\?/) ? "&" : "?"}jfalogin=1` : ""}`
      + `${match? match[2]: ''}`
    }},
    jticketImgUrl: function(){
      return value => `${process.env.VUE_APP_JLEAGUE_IMAGE_BASE_URL}${value}`
    },
    jticketVenueImgUrl: function(){
      return value => `${process.env.VUE_APP_JLEAGUE_IMAGE_BASE_URL}${process.env.VUE_APP_JLEAGUE_IMAGE_SEATCLASS_URL}${value}`
    },
    piaUrl: function(){
      return url => `${process.env.VUE_APP_PIA_URL}${url}`
    },
    cookiePolicyURL: function(){
      return url => `${process.env.VUE_APP_COOKIE_POLICY_URL}${url}`
    }
  }
}